import api from './api'
import authService from './authService'

class Service {
  constructor () {
    this.username = this.loadVar('username')
  }

  loadVar (name) {
    try {
      return JSON.parse(localStorage.getItem(name))
    } catch (e) {
      return ''
    }
  }

  saveVar (name, value) {
    return localStorage.setItem(name, JSON.stringify(value))
  }

  tryLogin (username, password) {
    this.saveVar('username', username)
    return api.get('/login', {
      __noToken: true,
      params: {
        login: username,
        password: password
      }
    }).then((response) => {
      authService.setToken(response.data.token.access_token, response.data.token.expires_in, response.data.token.refresh_token)
    })
  }
}

let loginService = new Service()

export default loginService



// WEBPACK FOOTER //
// ./src/utils/loginService.js